module.exports = __webpack_public_path__ + "static/media/filtersearch.246d0a84.svg";